import AuctionControl from "../components/AuctionControl";
import AuctionLog from "../components/AuctionLog";
import { useParams } from "react-router-dom";

const OrganizerAuctionControl = ({id}) => {
  const { gameId } = useParams();

  return (
    <div className="row">
      <div className="col-lg-9 mb-4">
        <AuctionControl gameId={gameId} />
      </div>
      <div className="col-lg-3 mb-4">
        <AuctionLog gameId={gameId} />
      </div>
    </div>
  );
};

export default OrganizerAuctionControl;
